import React from 'react'
import './Aboutme.css'

const Aboutme = () => {
  return (
    <>
    <div className='about-container1'>
      <div className="content">
        <div className="key">
          <div className="key-item"><span>Full Name</span></div>
          <div className="key-item"><span>Hometown</span></div>
          <div className="key-item"><span>Age</span></div>
          <div className="key-item"><span>Height</span></div>
          <div className="key-item"><span>Zodiac Sign</span></div>
          <div className="key-item"><span>Lucky no.</span></div>
          <div className="key-item"><span>Spirit Animal</span></div>
          
          
        </div>
        <div className="colon">
          {[...Array(7)].map((_,i)=>(
            <div key={i}><span>:</span></div>
          ))}
        </div>
        <div className="value">
          <div className="value-item">Usham <span>Adhitya</span> Luwang</div>
          <div className="value-item">Imphal, <span>Manipur</span></div>
          <div className="value-item">21 years <span>young</span></div>
          <div className="value-item">5<span>'</span> 8<span>''</span></div>
          <div className="value-item">Capricon</div>
          <div className="value-item">13</div>
          <div className="value-item">Wolf</div>
          
          
          
        </div>
      </div>
    </div>

    <div className='about-container2'>
      <div className="content">
        <div className="key">
          <div className="key-item"><span>Coffee or Tea</span></div>
          <div className="key-item"><span>Vibe</span></div>
          <div className="key-item"><span>Social Mode</span></div>
          <div className="key-item"><span>Languages</span></div>
          <div className="key-item"><span>Daily Activity</span></div>
          <div className="key-item"><span>Only thing I ask God</span></div>
          {/* <div className="key-item"><span>Red Flag</span></div> */}
        </div>
        <div className="colon">
          {[...Array(6)].map((_,i)=>(
            <div key={i}><span>:</span></div>
          ))}
        </div>
        <div className="value">
          <div className="value-item">Espresso</div>
          <div className="value-item">Travelling</div>
          <div className="value-item">Introverted</div>
          <div className="value-item">Meitei, <span>English</span>, Hindi & broken <span>Japanese</span></div>
          <div className="value-item">Gyming, Chess & Coding</div>
          <div className="value-item">Just keep me <span>Alive</span></div>
          {/* <div className="value-item">U hate <span>Chess</span>, <span>Talk</span> & Long <span>Walk</span></div> */}
        </div>
      </div>
      </div>
    </>
  )
}

export default Aboutme
